<!--suppress CssUnresolvedCustomProperty -->
<template>
    <div class="bg_main" :style="cssProps" v-resize="onResize">


        <!--   TABLE FOR PROCESSES (TABLETS AND PC)   -->
        <v-row>
            <v-col cols="12">
                <v-card class="py-2 px-4 processes-list">
                    
                    <h2 class="text-family my-2 ml-2">REALIZA UN NUEVO TRÁMITE</h2>
                    

                    <!-- <v-tabs fixed-tabs class="py-2" v-if="isMobile" style="overflowx"> 
                        <v-tab v-for="(category, i) in processesStore.categories" :key="'c'+i" ><v-card  @click="setSelectedCategory(category)"  style="" class="break-word" :href="`#`+category.id">{{ category.nombre.replace(/ .*/,'') }}</v-card> </v-tab>
                    </v-tabs> -->

                    <div  class="d-flex flex-row   overflow-scroll-x no-justify-center" color="transparent"  style="z-index:1;margin-bottom:-20px"  plain tile flat >
            
                        <v-card  
                        flat 
                        plain 
                        tile
                        depressed
                        v-for="(category, i) in processesStore.categories" 
                        color="transparent"
                        class="mb-2"
                        :key="'c'+i"
                        >
                            <v-btn 
                            plain
                            @click="setSelectedCategory(category)" 
                            class="mx-1 align-content-center align-center d-flex flex-column zoom-categorias btn-category mobile-catergory "
                            :class="i== 3 ? 'ml-5' : 0 "
                            :href="`#`+category.id"
                            >
                                    {{ category.nombre }}
                            </v-btn>


                            

                        </v-card>
                    </div>


                    <!-- <v-card class="d-flex align-center mb-2" style="height:50px"  :color="pantoneLight"> 
                        <v-icon class="ml-5">fas fa-mobile-alt</v-icon>
                        <a href="https://wa.me/5218120331341" target="_blank" class="ml-2 text--none text-decoration-none" style="color:black !important">consulta a tu asesor en linea</a>
                    </v-card> -->
                    <v-divider class="mt-2 mb-2"></v-divider>

                    <div v-for="(process, index) in processesStore.categories" :key="index" class="mt-8">
                        <h2 class="text-family ml-2" :id="process.id"> {{process.nombre}}</h2>
                            <sliderv v-if="processesStore.AllProcessByCategory" :data=" processesStore.AllProcessByCategory[index]" mode="session" :category="process.id" ></sliderv>                        
                    </div>


                </v-card>
            </v-col>
        </v-row>
        <!-- END TABLE FOR PROCESSES   -->
    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import {processListRequest} from "bestgob-core/api/models/";
import sliderv from '../components/SliderV.vue';


export default {
    name: "Processes",
    components: {
        sliderv
    },
    computed: {
        ...mapState({accountStore: state => state.account, processesStore: state => state.processes}),

        cssProps() {
            return {
                '--primary-color': this.$vuetify.theme.themes.light.primary
            }
        }
    },
    data() {
        return {
            currentCategoryId: 1,
            showIdentidad: true,
            selectedCategory: null,
            test: null,
            isMobile: false,
            pantone: '#B08C55',
            pantoneLight: '#fff5d3',
            pantoneBlack: '#15212F',
    }
    },

    created() {
        this.$gtag.event('nuevo_tramite', { method: 'Google' }) // Google Analytics
    },

    async mounted()  {
        //Call to VueX module action
        await this.getCategories()
        let categoriasOrdenadas = []
        let categoriasSinOrdenar = this.processesStore.categories

        let ordenDeCategorias = categoriasSinOrdenar.map(categoria => categoria.orden).sort();
        
        ordenDeCategorias.forEach(orden => {
            let categoriaaOrdenar =  categoriasSinOrdenar.find(categoria => categoria.orden == orden)
            categoriasOrdenadas.push(categoriaaOrdenar)
        })
        //Call to local method
        // this.getProcesses()

        //llama a todos los tramites por categoria
        this.getAllProcessByCategory(categoriasOrdenadas.length)

    },

    methods: {
        ...mapActions('processes', ['getProcesses', 'getCategories', 'getAllProcessByCategory',]),


        setSelectedCategory(category){
                if (category == null || category.id !== this.currentCategoryId){
                this.selectedCategory = category
                this.currentCategoryId = category ? category.id : 1
                }
        },

        getProcessesByCategory(category){
            if (category == null || category.id !== this.currentCategoryId){
                this.selectedCategory = category
                this.currentCategoryId = category ? category.id : 1

                let request = processListRequest()
                request.category_id = this.currentCategoryId
                request.type_of_person = this.accountStore.user.tipo_persona

                this.getProcesses(request)
            }
        },

        loadSVGIcon(iconName){
            import('./../components/icons/'+iconName.slice(0, -4));

            return iconName.slice(0, -4)
        },

        /** FOR MOBILE **/
        getSelectedCategoryIcon(){
            return this.loadSVGIcon(
                this.selectedCategory ? this.selectedCategory.icono: this.processesStore.categories[0].icono
            )
        },

        getSelectedCategoryLabel(){
            return this.selectedCategory ? this.selectedCategory.nombre: this.processesStore.categories[0].nombre
        },
        /** ENDS FOR MOBILE **/

        onResize() {
            if (window.innerWidth < 1000) this.isMobile = true;
            else  this.isMobile = false
        },
    },
}
</script>

<style >
    .category-menu .title{max-width: 170px}
    .category-menu .title{max-width: 170px}
    .category-menu.selected svg{
        fill: var(--primary-color) !important;
        opacity: 1;    
    }
    .category-menu svg {
        fill: #b3b3b3;
    }
    .tramite_ico svg{
        fill: #555;
    }
    .tramite_ico .v-card__text{
        color: #555 !important;
    }
    /* .category-menu.selected .prefix__cls-1{fill:var(--primary-color)} */
    .categories-header:hover {min-height: 40px}
    .processes-list {min-height: 80vh}
    .process-icon{height: 70px; overflow: hidden}
    .v-sheet.v-card:not(.v-sheet--outlined) {
        box-shadow: none !important;
    }


    .v-tabs:not(.v-tabs--vertical):not(.v-tabs--right) > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes) .v-slide-group__prev {
        display: none;
    }

    .v-tab--active{
        color:black !important
    }
    .v-tabs-slider{
        color: black !important;
    }

    .hover-categoria:hover{
         transform: scale(1.05);
        transition: .5s;
        z-index: 2;
    }

    .overflow-scroll-x{
        overflow-x: scroll;
    }
    ::-webkit-scrollbar {
        width: 0;  /* Remove scrollbar space */
        background: transparent;  /* Optional: just make scrollbar invisible */
    }

</style>
